import { Link } from 'react-router-dom'
import { useTranslator } from '../translator/hook'
import './noProject.css'
import { useContext } from 'react'
import { UserContext } from '../user/provider'

export const NoProject = () => {
  const { t } = useTranslator()
  const { isOnlineUser } = useContext(UserContext)
  const getOnlineLayout = () => {
    return (
      <div className="noproject-wrapper">
        <h1 className="noproject-title">{t('no_projects_yet')}</h1>
        <Link to={`${import.meta.env.VITE_DIGITANE_ONLINE_URL}/s/`}>
          <button className="no-project-back-big-button">
            {t('back_to_town')}
          </button>
        </Link>
      </div>
    )
  }

  const getLicenseLayout = () => {
    return (
      <div className="noproject-wrapper">
        <h1 className="noproject-title">{t('no_projects_yet')}</h1>
        <div className="noproject-license-text">
          {t('no_projects_yet_license')}
        </div>
      </div>
    )
  }

  return isOnlineUser ? getOnlineLayout() : getLicenseLayout()
}
